










import { store } from '@/utils/store';
import { getAvatarIconUrl } from '@/utils/utils';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SelfUserStatus extends Vue {
  get name() {
    return store.githubId ?? 'ssssota';
  }
  get icon() {
    return getAvatarIconUrl(this.name);
  }
  get status() {
    return store.status;
  }

  get path() {
    return this.$route.params.userId ?? '';
  }

  toSelfUserProfile() {
    if (this.$route.params.userId !== this.name) this.$router.push({ name: 'User', params: { userId: this.name ?? '' } });
  }
}
